import { Box, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import type { WidgetProps } from './WidgetProps'

/**
 * Сводка бухгалтерии за текущий месяц: валовый доход крупно (основная
 * метрика по запросу учителей), ниже — налог, расходы и чистый доход.
 */
export function AccountingSummaryWidget({ payload }: WidgetProps) {
  const { t } = useTranslation()

  const currency = String(payload.currency ?? 'RUB')
  const money = (value: unknown) => `${String(value ?? '0.00')} ${currency === 'RUB' ? '₽' : currency}`

  return (
    <Stack spacing={1}>
      <Box>
        <Typography variant="caption" color="text.secondary">
          {t('dashboard.widgets.accounting_summary.gross')}
        </Typography>
        <Typography variant="h5" fontWeight={700}>
          {money(payload.gross)}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 2, rowGap: 0.5 }}>
        <Typography variant="body2" color="text.secondary">
          {t('dashboard.widgets.accounting_summary.tax')}: {money(payload.tax)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('dashboard.widgets.accounting_summary.expenses')}: {money(payload.expenses)}
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          {t('dashboard.widgets.accounting_summary.net')}: {money(payload.net)}
        </Typography>
      </Box>
      <MuiLink component={RouterLink} to={ROUTES.ACCOUNTING} underline="hover" variant="caption">
        {t('dashboard.widgets.accounting_summary.open')}
      </MuiLink>
    </Stack>
  )
}
